<template>
  <section :class="$style.container">
    <ButtonLoginSwitch
      v-if="!redirectTo"
      :clickHandler="goToAdminLogin"
    >
      Administrator Login
    </ButtonLoginSwitch>
    <div :class="$style.formContainer">
      <UserLoginForm
        :autofocus="autofocus"
        :form="form"
        :goToAdminLogin="goToAdminLogin"
        :loadingErrorMsg="error"
        :loadingSuccessMsg="success"
        :updateAutofocus="updateAutofocus"
        v-bind="$props"
      />
      <LogoIcon />
    </div>
  </section>
</template>

<script>
import ButtonLoginSwitch from 'client/components/ButtonLoginSwitch.vue';
import Constants from 'client/util/Constants';
import Cookies from 'js-cookie';
import LoginConsts from 'client/util/Constants/LoginConstants';
import LogoIcon from 'client/components/LogoIcon.vue';
import UserLoginForm from 'client/containers/Login/UserLoginForm.vue';
import loginUtil from 'client/components/mixins/loginUtil';

const { redirectTo } = Constants;
const { clientType, clientTypeCookie } = LoginConsts;

export default {
  name: 'UserLoginWrapper',

  mixins: [loginUtil],

  components: {
    LogoIcon,
    UserLoginForm,
    ButtonLoginSwitch,
  },

  props: {
    clientType: {
      type: String,
      default: clientType.user,
    },
    error: {
      type: String,
      default: undefined,
    },
    success: {
      type: String,
      default: undefined,
    },
    redirectTo: {
      type: String,
      default: '',
    },
    requestKey: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => ({
        email: '',
        password: '',
      }),
    },
  },

  methods: {
    goToAdminLogin() {
      // removing redirectTo from session to prevent issues when swtiching clientTypes
      sessionStorage.removeItem(redirectTo);
      this.vueRouteChange('Admin Login', { form: this.form });
    },
  },

  mounted() {
    Cookies.set(clientTypeCookie, 'user');
  },
};
</script>

<style module>
@import '../../css/login-components.css';

.container {
  padding: 1rem;
}
</style>
